/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_CpsInputs */



/**
* | output |
* | --- |
* | "CPS" |
*
* @param {Editor_Table_Column_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_cps = /** @type {((inputs?: Editor_Table_Column_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "de") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "it") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "es") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中央公共系统")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CPS")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीपी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("CPS")
	return /** @type {LocalizedString} */ ("CPS")
});